import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './LiveScoreTicker.css'

// ============================================================
// TEAM LOGOS
// Uses the same logo files as FullSchedule.js
// ============================================================

import backstromBoys from '../../images/teamLogos/Backstrom boys.png'
import berserkers from '../../images/teamLogos/Berserkers 2.png'
import blackWidows from '../../images/teamLogos/Black Widows.png'
import bolts from '../../images/teamLogos/Bolts.jpg'
import bombers from '../../images/teamLogos/Bombers.png'
import bonnieNClyde from '../../images/teamLogos/Bonnie n clyde.jpg'
import capitalPunishment from '../../images/teamLogos/Capital punishment.png'
import chops from '../../images/teamLogos/Carolina chops.png'
import chernobyl from '../../images/teamLogos/Chernobyl.png'
import chimneyFish from '../../images/teamLogos/Chimney fish.png'
import dcCorruption from '../../images/teamLogos/Dc corruption.jpg'
import ehHoles from '../../images/teamLogos/Eh-holes.png'
import firstLadies from '../../images/teamLogos/First ladies.jpg'
import freeze from '../../images/teamLogos/Freeze.png'
import gjwthf from '../../images/teamLogos/GJWTHF.png'
import goldenGirls from '../../images/teamLogos/Golden girls.png'
import graffix from '../../images/teamLogos/Graffix.png'
import grenlockMonsters from '../../images/teamLogos/Grenlock monsters.png'
import heathens from '../../images/teamLogos/Heathens.png'
import hiredGuns from '../../images/teamLogos/Hired Guns.png'
import invaders from '../../images/teamLogos/Invaders.png'
import mallards from '../../images/teamLogos/Mallards.png'
import mooseKnuckles from '../../images/teamLogos/mooseKnuckles.png'
import redWolves from '../../images/teamLogos/redWolves.PNG'
import sassNSpades from '../../images/teamLogos/sassNSpades.PNG'
import midnightExpress from '../../images/teamLogos/Midnight express.png'
import misfits from '../../images/teamLogos/Misfits Coed.png'
import missConducts from '../../images/teamLogos/Miss conducts.jpg'
import nightswatchBlack from '../../images/teamLogos/Nightswatch Black.png'
import nightswatchWhite from '../../images/teamLogos/Nightswatch White.png'
import ninjaTurtles from '../../images/teamLogos/Ninja turtles.jpg'
import nukes from '../../images/teamLogos/Nukes.png'
import pigeons from '../../images/teamLogos/Ny pigeons.png'
import purplePower from '../../images/teamLogos/Purple power.png'
import roastMellows from '../../images/teamLogos/Roast mellows.png'
import rockies from '../../images/teamLogos/Rockies.png'
import ronin from '../../images/teamLogos/Ronin.png'
import saltyCrabsMensA from '../../images/teamLogos/Salty Crabs mens A.png'
import shortis from '../../images/teamLogos/Shortis Logo.PNG'
import sjCyclones from '../../images/teamLogos/SJ cyclones.png'
import sjEnforcers from '../../images/teamLogos/SJ enforcers.png'
import sjsharks from '../../images/teamLogos/SJ sharks.png'
import southBolts from '../../images/teamLogos/South bolts.jpg'
import southHillsBandits from '../../images/teamLogos/South Hills Bandit.png'
import southSiders from '../../images/teamLogos/South Siders.png'
import stallions from '../../images/teamLogos/Stallions.png'
import thugBunnies from '../../images/teamLogos/Thug bunnies.jpg'
import venom from '../../images/teamLogos/venom.png'
import caniseCarai from '../../images/teamLogos/Canise Carai.PNG'
import doggPound from '../../images/teamLogos/doggPound.png'
import ellasFellas from '../../images/teamLogos/ellasFellas.png'
import rabidRaccoons from '../../images/teamLogos/Rabid raccoons.png'
import stingrays from '../../images/teamLogos/stingrays.PNG'
import vengeance from '../../images/teamLogos/Vengeance.png'
import banksvilleBucks from '../../images/teamLogos/banksvilleBucks.PNG'
import mckeesportPaladins from '../../images/teamLogos/McKeesportPaladins.png'
import starhawks from '../../images/teamLogos/starhawks.PNG'
import bridgers from '../../images/teamLogos/bridgers.png'
import jhamericans from '../../images/teamLogos/JH_Americans.png'
import thrustfund from '../../images/teamLogos/ThrustFund.png'
import offsides from '../../images/teamLogos/offsides.PNG'

const teamLogoMap = {
	'Backstrom Boys': backstromBoys,
	Berserkers: berserkers,
	'Black Widows': blackWidows,
	Bolts: bolts,
	Bombers: bombers,
	'Bonnie N Clyde': bonnieNClyde,
	'Capital Punishment': capitalPunishment,
	Chops: chops,
	Chernobyl: chernobyl,
	'Chimney Fish': chimneyFish,
	'DC Corruption': dcCorruption,
	'Eh-Holes': ehHoles,
	'First Ladies': firstLadies,
	Freeze: freeze,
	GJWTHF: gjwthf,
	'Golden Girls': goldenGirls,
	Graffix: graffix,
	'Grenlock Monsters': grenlockMonsters,
	Heathens: heathens,
	'Hired Guns': hiredGuns,
	Invaders: invaders,
	'Midnight Express': midnightExpress,
	Misfits: misfits,
	'Miss Conducts': missConducts,
	'Nights Watch Black': nightswatchBlack,
	'Nights Watch White': nightswatchWhite,
	'Nights Watch': nightswatchBlack,
	'Ninja Turrles': ninjaTurtles,
	Nukes: nukes,
	Pigeons: pigeons,
	'Purple Power': purplePower,
	'Roast Mellows': roastMellows,
	Rockies: rockies,
	Ronin: ronin,
	'Salty Crabs': saltyCrabsMensA,
	Shortis: shortis,
	Cyclones: sjCyclones,
	Enforcers: sjEnforcers,
	Sharks: sjsharks,
	'South Bolts': southBolts,
	Bandits: southHillsBandits,
	'South Siders': southSiders,
	Stallions: stallions,
	'Thug Bunnies': thugBunnies,
	Venom: venom,
	Mallards: mallards,
	'Sass N Spades': sassNSpades,
	'Raleigh Red Wolves': redWolves,
	'Moose Knuckles': mooseKnuckles,
	'Canise Carai-Pereira': caniseCarai,
	'Dogg Pound': doggPound,
	"Ella's Fellas": ellasFellas,
	'Rabid Raccoons': rabidRaccoons,
	Stingrays: stingrays,
	Vengeance: vengeance,
	'Banksville Bucks': banksvilleBucks,
	McKeesport: mckeesportPaladins,
	StarHawks: starhawks,
	Bridgers: bridgers,
	'JH Americans': jhamericans,
	'Thrust Fund': thrustfund,
	Offsides: offsides,
}

// ============================================================
// HELPERS
// ============================================================

const getStatus = (game) => {
	const status = String(game.tickerStatus || '').toUpperCase()

	if (status === 'FINAL') return 'FINAL'
	if (status === 'LIVE') return 'LIVE'
	return 'UP NEXT'
}

const getDivision = (game) => {
	if (game.playoff) {
		return game.playoffDivision || game.divisionName || 'Playoff'
	}

	return game.divisionName || 'Division TBD'
}

const getScore = (game, status) => {
	if (status === 'UP NEXT') return 'VS'

	if (game.liveScore) return game.liveScore

	if (game.score) return game.score

	return '0 - 0'
}

// ============================================================
// INDIVIDUAL GAME CARD
// ============================================================

const TickerGame = ({ game }) => {
	const status = getStatus(game)

	const homeLogo = teamLogoMap[game.homeTeamName]
	const visitorLogo = teamLogoMap[game.visitorTeamName]

	const isFinal = status === 'FINAL'
	const Wrapper = isFinal ? Link : 'div'

	return (
		<Wrapper
			{...(isFinal ? { to: `/gameSummary/${game._id}` } : {})}
			className='liveScoreTicker__game'
			title={`${game.homeTeamName} vs ${game.visitorTeamName}`}
		>
			<div
				className={`liveScoreTicker__status liveScoreTicker__status--${status
					.toLowerCase()
					.replace(' ', '-')}`}
			>
				{status === 'LIVE' && <span className='liveScoreTicker__liveDot' />}

				{status}
			</div>

			<div className='liveScoreTicker__matchup'>
				<div className='liveScoreTicker__team'>
					{homeLogo ? (
						<img src={homeLogo} alt='' />
					) : (
						<div className='liveScoreTicker__logoFallback'>
							{game.homeTeamName?.charAt(0) || '?'}
						</div>
					)}

					<span>{game.homeTeamName || 'TBD'}</span>
				</div>

				<div className='liveScoreTicker__score'>{getScore(game, status)}</div>

				<div className='liveScoreTicker__team'>
					{visitorLogo ? (
						<img src={visitorLogo} alt='' />
					) : (
						<div className='liveScoreTicker__logoFallback'>
							{game.visitorTeamName?.charAt(0) || '?'}
						</div>
					)}

					<span>{game.visitorTeamName || 'TBD'}</span>
				</div>
			</div>

			<div className='liveScoreTicker__footer'>
				<span>{getDivision(game)}</span>
				<span className='liveScoreTicker__venue'>{game.venueName}</span>
			</div>
		</Wrapper>
	)
}

// ============================================================
// MAIN COMPONENT
// ============================================================

const LiveScoreTicker = ({ refreshInterval = 30000 }) => {
	const [games, setGames] = useState([])
	const [enabled, setEnabled] = useState(false)
	const [paused, setPaused] = useState(false)
	const [pageVisible, setPageVisible] = useState(() => !document.hidden)

	// ----------------------------------------------------------
	// CHECK ADMIN ON/OFF SETTING
	// ----------------------------------------------------------

	useEffect(() => {
		let active = true

		const checkSettings = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/liveScoreTicker/settings`,
				)

				if (!response.ok) {
					throw new Error('Unable to load ticker settings')
				}

				const data = await response.json()

				if (active) {
					setEnabled(data.liveScoreTickerEnabled === true)
				}
			} catch (err) {
				console.error('Live ticker settings:', err.message)

				if (active) {
					setEnabled(false)
				}
			}
		}

		checkSettings()

		const interval = setInterval(checkSettings, 120000)

		return () => {
			active = false
			clearInterval(interval)
		}
	}, [])

	// ----------------------------------------------------------
	// TRACK BROWSER TAB VISIBILITY
	// ----------------------------------------------------------

	useEffect(() => {
		const handleVisibility = () => {
			setPageVisible(!document.hidden)
		}

		document.addEventListener('visibilitychange', handleVisibility)

		return () => {
			document.removeEventListener('visibilitychange', handleVisibility)
		}
	}, [])

	// ----------------------------------------------------------
	// LOAD SCORES ONLY WHEN ENABLED
	// ----------------------------------------------------------

	useEffect(() => {
		if (!enabled || !pageVisible) return

		let active = true
		const controller = new AbortController()

		const loadGames = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/liveScoreTicker`,
					{ signal: controller.signal },
				)

				if (!response.ok) {
					throw new Error('Unable to load live scores')
				}

				const data = await response.json()

				if (active) {
					setGames(data.games || [])
				}
			} catch (err) {
				if (err.name !== 'AbortError') {
					console.error('Live ticker:', err.message)
				}
			}
		}

		loadGames()

		const interval = setInterval(loadGames, refreshInterval)

		return () => {
			active = false
			controller.abort()
			clearInterval(interval)
		}
	}, [enabled, pageVisible, refreshInterval])

	// ----------------------------------------------------------
	// HIDE WHEN DISABLED OR NO GAMES
	// ----------------------------------------------------------

	if (!enabled || games.length === 0) {
		return null
	}

	const renderGames = (copy) =>
		games.map((game) => <TickerGame key={`${copy}-${game._id}`} game={game} />)

	return (
		<section className='liveScoreTicker' aria-label='Live tournament scores'>
			<div className='liveScoreTicker__viewport'>
				<div
					className={`liveScoreTicker__track ${
						paused ? 'liveScoreTicker__track--paused' : ''
					}`}
					style={{
						'--ticker-duration': `${Math.max(25, games.length * 7)}s`,
					}}
				>
					<div className='liveScoreTicker__group'>{renderGames('first')}</div>

					<div className='liveScoreTicker__group' aria-hidden='true'>
						{renderGames('second')}
					</div>
				</div>
			</div>

			<button
				type='button'
				className='liveScoreTicker__pause'
				onClick={() => setPaused((previous) => !previous)}
				aria-label={paused ? 'Resume score ticker' : 'Pause score ticker'}
			>
				{paused ? '▶' : 'Ⅱ'}
			</button>
		</section>
	)
}

export default LiveScoreTicker
